/* @flow */
import * as React from 'react';
// import _ from 'lodash';

import styles from './styles.module.scss';
import ActionButton from '../ActionButton';
import i18n from '../../i18n';

import type { Item } from '../ActionButton';
import type { Fetchable, SimplifiedWorklist } from '../../types';

export type ClickableWorklist = SimplifiedWorklist & { onClick?: () => any };
type ItemProps = {
  label?: any,
  onClick?: () => mixed,
  tooltip?: string,
};

export type Props = {
  sessionUsageId?: number,
  buy?: Fetchable<ItemProps[]>,
  cannotBuy?: Fetchable<() => any | void>,
  download?: Fetchable<() => any | void>,
  ask?: Fetchable<() => any | void>,
  delete?: Fetchable<() => any | void>,
  worklist?: Fetchable<ClickableWorklist>,
  worklists?: Fetchable<ClickableWorklist[]>,
  worklist1?: Fetchable<ClickableWorklist>,
  worklist2?: Fetchable<ClickableWorklist>,
};

type FetchableButtonProps<T> = { itemFn: T => Item } & Item & Fetchable<T>;
const FetchableActionButton = <T>(props: FetchableButtonProps<T>) => {
  const { data, fetching, error, disabled, itemFn, iconName, ...other } = props;
  if (fetching) {
    return (
      <ActionButton
        {...other}
        iconName={iconName}
        disabled={true}
        loading={true}
        tooltip={`${i18n.t('LOADING')}...`}
      />
    );
  } else if (error) {
    return <ActionButton {...other} iconName={iconName} disabled={true} tooltip={error.message} />;
  } else if (data) {
    return <ActionButton {...other} {...itemFn(data)} iconName={iconName} disabled={!!disabled} />;
  }
  return null;
};

const WorklistButton = (worklist: Fetchable<ClickableWorklist>) => {
  const item = (data: ClickableWorklist) => ({
    iconName: 'worklist',
    title: `${i18n.t('GO_TO_WORKLIST')}`,
    tooltip: `${i18n.t('GO_TO_WORKLIST')}`,
    onClick: data,
  });
  return <FetchableActionButton {...worklist} iconName={'worklist'} itemFn={item} />;
};

const Worklist1Button = (worklist1: Fetchable<ClickableWorklist>) => {
  const item = (data: ClickableWorklist) => ({
    iconName: 'add_to_worklist_1',
    title: `${i18n.t('ADD_TO')} ${data.name || 'Worklist 1'}`,
    tooltip: `${i18n.t('ADD_TO')} ${data.name || 'Worklist 1'}`,
    onClick: data.onClick,
  });
  return <FetchableActionButton {...worklist1} iconName={'add_to_worklist_1'} itemFn={item} />;
};

const Worklist2Button = (worklist2: Fetchable<ClickableWorklist>) => {
  const item = (data: ClickableWorklist) => ({
    iconName: 'add_to_worklist_2',
    title: `${i18n.t('ADD_TO')} ${data.name || 'Worklist 2'}`,
    tooltip: `${i18n.t('ADD_TO')} ${data.name || 'Worklist 2'}`,
    onClick: data.onClick,
  });
  return <FetchableActionButton {...worklist2} iconName={'add_to_worklist_2'} itemFn={item} />;
};

/* type FetchableActionMenuButtonProps<T> = { itemFn: T => Item } & Item & Fetchable<T[]>;
const FetchableActionMenuButton = <T>(props: FetchableActionMenuButtonProps<T>) => {
  const { data, fetching, error, itemFn, iconName, ...other } = props;
  if (fetching) {
    return (
      <ActionButton
        {...other}
        iconName={iconName}
        disabled={true}
        loading={true}
        tooltip={`${i18n.t('LOADING')}...`}
      />
    );
  } else if (error) {
    return <ActionButton {...other} iconName={iconName} disabled={true} tooltip={error.message} />;
  } else if (data) {
    return (
      <ActionButton {...other} iconName={iconName} items={_.isArray(data) && data.map(itemFn)} />
    );
  }
  return null;
}; */
const WorklistsButton = (worklists: Fetchable<ClickableWorklist[]>) => {
  const itemFn = (data: ClickableWorklist) => ({
    iconName: data.onClick && 'add',
    label: data.name,
    onClick: data.onClick,
    tooltip: data.name,
    // children: data.children
    //   ? data.children.map(child => ({
    //       iconName: child.onClick && 'add',
    //       label: child.name,
    //       onClick: child.onClick,
    //       tooltip: child.name,
    //     }))
    //   : null,
  });
  return <FetchableActionButton {...worklists} iconName={'add_to_worklist'} itemFn={itemFn} />;
};

const BuyButton = (buy: Fetchable<ItemProps[]>) => {
  const item = (data: any) => ({
    iconName: data.onClick && 'add',
    label: data.name,
    //</T></T>onClick: data.onClick,
    //</T>tooltip: data.name,
    // children: data.children
    //   ? data.children.map(child => ({
    //       iconName: child.onClick && 'add',
    //       label: child.name,
    //       onClick: child.onClick,
    //       tooltip: child.name,
    //     }))
    //   : null,
  });
  return <FetchableActionButton {...buy} iconName={'shopping_cart'} itemFn={item} />;
};

const CannotBuyButton = (cannotBuy: Fetchable<() => any>) => {
  const item = (data: () => any) => ({
    iconName: 'remove_shopping_cart',
    onClick: data,
    title: i18n.t('CANNOT_BUY'),
    tooltip: i18n.t('CANNOT_BUY'),
  });
  return <FetchableActionButton {...cannotBuy} iconName={'remove_shopping_cart'} itemFn={item} />;
};

const DownloadButton = (download: Fetchable<() => any>) => {
  const { fetchable } = download;
  const item = (data: () => any) => ({
    iconName: 'download',
    onClick: data,
    title: i18n.t('DOWNLOAD'),
    tooltip: i18n.t('DOWNLOAD'),
  });
  return (
    <FetchableActionButton
      {...download}
      iconName={'download'}
      itemFn={item}
      disabled={!fetchable}
    />
  );
};

const AskButton = (ask: Fetchable<() => any>) => {
  const item = (data: () => any) => ({
    iconName: 'ask',
    onClick: data,
    title: i18n.t('ASK_QUOTATION'),
    tooltip: i18n.t('ASK_QUOTATION'),
  });
  return <FetchableActionButton {...ask} iconName={'ask'} itemFn={item} />;
};

const DeleteButton = (_delete: Fetchable<() => any>) => {
  const item = (data: () => any) => ({
    iconName: 'delete',
    onClick: data,
    title: i18n.t('DELETE'),
    tooltip: i18n.t('DELETE'),
  });
  return <FetchableActionButton {..._delete} iconName={'delete'} itemFn={item} />;
};

class TracksActionButtons extends React.Component<Props, void> {
  render() {
    const {
      worklist,
      worklists,
      worklist1,
      worklist2,
      buy,
      cannotBuy,
      download,
      ask,
      delete: _delete,
      ...otherProps
    } = this.props;
    return (
      <div className={styles.container} {...otherProps}>
        {worklist ? <WorklistButton {...worklist} /> : null}
        {worklist1 ? <Worklist1Button {...worklist1} /> : null}
        {worklist2 ? <Worklist2Button {...worklist2} /> : null}
        {worklists ? <WorklistsButton {...worklists} /> : null}
        {buy ? <BuyButton {...buy} /> : null}
        {cannotBuy ? <CannotBuyButton {...cannotBuy} /> : null}
        {download ? <DownloadButton {...download} /> : null}
        {ask ? <AskButton {...ask} /> : null}
        {_delete ? <DeleteButton {..._delete} /> : null}
      </div>
    );
  }
}

export default TracksActionButtons;
